module.exports = function () { /* empty */ };



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/_add-to-unscopables.js